import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=264be14a&scoped=true&"
import script from "./Supervisor.vue?vue&type=script&lang=js&"
export * from "./Supervisor.vue?vue&type=script&lang=js&"
import style0 from "./Supervisor.vue?vue&type=style&index=0&id=264be14a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264be14a",
  null
  
)

export default component.exports